import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiCall } from "../../api/index";
import { showLoading } from "../slice/loadingSlice";
import { baseUrl } from "../../constant/baseurl";

const createAccountAsyncThunk = (method, type, contentType, url) =>
  createAsyncThunk(type, async (payload, thunkAPI) => {
    const { data } = payload;
    const { dispatch } = thunkAPI;
    const token = localStorage.getItem("token");
    const apiRequest = {
      method: method,
      headers: token
        ? {
            "Content-Type": contentType,
            Authorization: "Token " + localStorage.getItem("token"),
          }
        : { "Content-Type": contentType },
      url: `${baseUrl}${url}`,
    //   url: `${url}`,
      data,
    };

    try {
      dispatch(showLoading.actions.toggleLoading(true));
      const res = await apiCall(apiRequest, dispatch);
      const response = res.data;

      dispatch(showLoading.actions.toggleLoading(false));

      if (response.statusFlag === true) {
        console.log(`login action ------ ${type}`, response);
        return response;
      } else {
        console.error(`account action - ${type}`, response);

        // Check if there is an error code in the response
        const errorCode = response.message;

        // You can throw a custom error with the error code
        throw new Error(errorCode);
      }
    } catch (error) {
      dispatch(showLoading.actions.toggleLoading(false));
      throw error;
    }
  });

  export const fetchInvoiceData = createAccountAsyncThunk(
    "get",
    "fetchInvoiceData",
    "application/json",
    "valiantinfo_admin/admin_invoice_generation/fetch_invoice_data/"
   );

  export const fechInvoiceSingleDataList = createAccountAsyncThunk(
    "post",
    "fechInvoiceSingleDataList",
    "application/json",
    "valiantinfo_admin/admin_invoice_generation/fetch_invoice_single_data_list/"
   );

  export const updateInvoiceGeneration = createAccountAsyncThunk(
    "put",
    "updateInvoiceGeneration",
    "application/json",
    "valiantinfo_admin/admin_invoice_generation/update_invoice_generation/"
   );

  export const adminApproveInvoice = createAccountAsyncThunk(
    "put",
    "adminApproveInvoice",
    "application/json",
    "valiantinfo_admin/admin_invoice_generation/admin_approved_invoice_details/"
   );


   export const invoiceApproveList = createAccountAsyncThunk(
    "post",
    "invoiceApproveList",
    "application/json",
    "valiantinfo_admin/admin_invoice_generation/invoice_approve_list/"
  );

  export const fetchApproveInvoiceSingleList = createAccountAsyncThunk(
    "post",
    "fetchApproveInvoiceSingleList",
    "application/json",
    "valiantinfo_admin/admin_invoice_generation/fetch_approve_invoice_single_list/"
  );

  export const financeApproveInvoice = createAccountAsyncThunk(
    "put",
    "financeApproveInvoice",
    "multipart/form-data",
    "valiantinfo_admin/admin_invoice_generation/finance_approved_invoice_details/"
   );

  export const sendInvoiceEmail = createAccountAsyncThunk(
    "post",
    "sendInvoiceEmail",
    "application/json",
    "valiantinfo_admin/admin_invoice_generation/send_vendor_invoice_email/"
   );

   export const GenerateInvoiceProofUrl = createAccountAsyncThunk(
    "post",
    "GenerateInvoiceProofUrl",
    "multipart/form-data",
    "valiantinfo_admin/admin_settings/generate_invoiceproof_url/"
   );
   

   export const updateInvoicePaymentDetails = createAccountAsyncThunk(
    "post",
    "updateInvoicePaymentDetails",
    "application/json",
    "valiantinfo_admin/admin_invoice_generation/update_invoice_payment_details/"
   );

export const generateLateFeeInvoice = createAccountAsyncThunk(
  "post",
  "generateLateFeeInvoice",
  "application/json",
  "valiantinfo_admin/admin_invoice_generation/late-fee_invoice/"
);

export const getLateFeeInvoices = createAccountAsyncThunk(
  "post",
  "getLateFeeInvoices",
  "application/json",
  "valiantinfo_admin/admin_invoice_generation/get_late-fee_invoice_details/"
);

export const updateLateInvoicePaymentDetails = createAccountAsyncThunk(
  "post",
  "updateLateInvoicePaymentDetails",
  "application/json",
  "valiantinfo_admin/admin_invoice_generation/update_late_invoice_payment_details/"
);

export const activateDeactivateVendorStatus = createAccountAsyncThunk(
  "post",
  "activateDeactivateVendorStatus",
  "application/json",
  "valiantinfo_admin/admin_invoice_generation/activate_deactivate_vendor_status/"
);

export const getPaidInvoiceDetails = createAccountAsyncThunk(
  "get",
  "getPaidInvoiceDetails",
  "application/json",
  "valiantinfo_admin/admin_invoice_generation/paid_invoice_details/"
);

export const generateFrobinInvoice = createAccountAsyncThunk(
  "post",
  "generateFrobinInvoice",
  "application/json",
  "valiantinfo_admin/admin_invoice_generation/frobin_invoice/"
);
